import type { SlotDef } from "./types";

/**
 * What a slot will accept, for the form to *say* — `asset-cover-art` DE-D4.
 *
 * A mirror of `infra/lambda/backend/services/AssetKeys.ts`, and a mirror in the
 * same sense `gate.ts` is one (§11.4): **the server decides.** The limit is
 * signed into the presigned PUT as `ContentLength`, so S3 refuses a body of any
 * other length whether or not this file agrees. Nothing here is a boundary.
 *
 * It exists so the form can tell a creator the limit *before* they pick a 12 MB
 * file, rather than after the round trip. If the two ever drift, the server
 * wins and the only cost is a rejection the UI failed to predict.
 */

const IMAGE_EXTENSIONS = [".png", ".jpg", ".jpeg", ".gif", ".webp"];

export const MAX_UPLOAD_BYTES = 25 * 1024 * 1024;
export const MAX_IMAGE_UPLOAD_BYTES = 5 * 1024 * 1024;

export const isImageSlot = (accept: readonly string[]): boolean =>
  accept.length > 0 && accept.every((a) => IMAGE_EXTENSIONS.includes(a.toLowerCase()));

export function capFor(slot: Pick<SlotDef, "accept" | "maxBytes">): number {
  if (typeof slot.maxBytes === "number" && slot.maxBytes > 0) return slot.maxBytes;
  return isImageSlot(slot.accept) ? MAX_IMAGE_UPLOAD_BYTES : MAX_UPLOAD_BYTES;
}
